import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
    updateSubscription: (state, action) => {
      if(state.user){
        state.user.subscription = action.payload;
      }
    },
  },
});

export const selectAuthToken = (state) => state?.auth?.user?.jwttoken;
export const { login, logout, updateSubscription } = authSlice.actions;
export default authSlice.reducer;